<div class="home-layout">
  <app-header></app-header>
  <div class="main-content">
    <app-navigation></app-navigation>
    <div class="content-area" [ngClass]="{ 'expanded-menu': isMenuExpanded }">
      <ng-container [ngSwitch]="selectedMenuItem">
        <div *ngSwitchCase="'Home'" class="component-container">
          <!-- Default home content or home component -->
          <h2>Welcome to MSP Navigator Site Admin</h2>
          <p>
            Select a client from the dropdown menu in the header, then choose a
            menu option from the left sidebar to access the corresponding
            features.
          </p>
        </div>
        <div *ngSwitchCase="'User Administrators'" class="component-container">
          <app-user-administrators></app-user-administrators>
        </div>
        <div *ngSwitchCase="'Notifications'" class="component-container">
          <app-notifications [clientID]="selectedClientID"></app-notifications>
        </div>
        <div *ngSwitchCase="'RRE Linking'" class="component-container">
          <app-rrelinking></app-rrelinking>
        </div>
        <div *ngSwitchCase="'Recovery Agents'" class="component-container">
          <app-recoveryagents></app-recoveryagents>
        </div>
        <div *ngSwitchCase="'RRE Management'" class="component-container">
          <app-rremanagement></app-rremanagement>
        </div>
        <div *ngSwitchCase="'TPA RRE Management'" class="component-container">
          <app-tparremanagement></app-tparremanagement>
        </div>
        <div *ngSwitchCase="'Data Load Management'" class="component-container">
          <app-dataloadmanagement></app-dataloadmanagement>
        </div>
        <div *ngSwitchCase="'QA Tools'" class="component-container">
          <app-qatools></app-qatools>
        </div>
        <div *ngSwitchCase="'Service Management'" class="component-container">
          <app-servicemanagement></app-servicemanagement>
        </div>
        <div *ngSwitchCase="'Claim Reassignment'" class="component-container">
          <app-claim-reassignment></app-claim-reassignment>
        </div>
        <div *ngSwitchCase="'Adjuster Management'" class="component-container">
          <app-adjuster-management></app-adjuster-management>
        </div>
        <div
          *ngSwitchCase="'API Request/Response Info'"
          class="component-container"
        >
          <app-apirequestresponseinfo></app-apirequestresponseinfo>
        </div>
        <div
          *ngSwitchCase="'Rest API Request/Response Details'"
          class="component-container"
        >
          <app-rest-api-request-response-details></app-rest-api-request-response-details>
        </div>
        <div
          *ngSwitchCase="'SFTP Migration Config'"
          class="component-container"
        >
          <app-sftp-migration-configuration></app-sftp-migration-configuration>
        </div>
        <div
          *ngSwitchCase="'SFTP File Movement Logs'"
          class="component-container"
        >
          <app-file-movement-logs></app-file-movement-logs>
        </div>
        <div *ngSwitchDefault class="component-container">
          <h2>Welcome to MSP Navigator Site Admin</h2>
          <p>
            Select a client from the dropdown menu in the header, then choose a
            menu option from the left sidebar to access the corresponding
            features.
          </p>
        </div>
      </ng-container>
    </div>
  </div>
  <app-footer></app-footer>
</div>
